(function () {
  'use strict';

  var STORAGE_KEY = 'orion_price_display';
  var DEFAULT_MODE = 'HT';
  var VAT_MULTIPLIER = 1.2;
  var PRICE_SELECTOR = '[data-orion-price-ht-cents], [data-fixed-quantity-main-price], [data-orion-fixed-unit-price], [data-orion-proxy-from-price]';

  function normalizeMode(value) {
    return String(value || '').toUpperCase() === 'TTC' ? 'TTC' : DEFAULT_MODE;
  }

  function getMode() {
    try {
      return normalizeMode(window.localStorage.getItem(STORAGE_KEY));
    } catch (_error) {
      return DEFAULT_MODE;
    }
  }

  function saveMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, normalizeMode(mode));
    } catch (_error) {
      // The display still works when storage is unavailable.
    }
  }

  function formatMoney(cents, currency) {
    var amount = Math.max(0, Math.round(Number(cents) || 0)) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_error) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function parseDisplayedCents(text) {
    var match = String(text || '').match(/-?\d[\d\s.]*([,.]\d+)?/);
    if (!match) return null;
    var numeric = match[0]
      .replace(/[^0-9,.-]/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');
    var value = Number.parseFloat(numeric);
    return Number.isFinite(value) ? Math.round(value * 100) : null;
  }

  function updateSourceIfExternallyChanged(node) {
    if (!node.dataset.orionRenderedText || node.textContent === node.dataset.orionRenderedText) return;
    var cents = parseDisplayedCents(node.textContent);
    if (cents !== null) node.dataset.orionPriceHtCents = String(cents);
  }

  function renderPrice(node, mode) {
    updateSourceIfExternallyChanged(node);
    if (!node.dataset.orionPriceHtCents) {
      var detectedCents = parseDisplayedCents(node.textContent);
      if (detectedCents !== null) node.dataset.orionPriceHtCents = String(detectedCents);
    }
    var htCents = Number(node.dataset.orionPriceHtCents);
    if (!Number.isFinite(htCents)) return;
    var displayCents = mode === 'TTC' ? Math.round(htCents * VAT_MULTIPLIER) : Math.round(htCents);
    var text = formatMoney(displayCents, node.dataset.orionCurrency) + ' ' + mode + (node.dataset.orionPriceSuffix || '');
    if (node.textContent !== text) node.textContent = text;
    node.dataset.orionRenderedText = text;
  }

  function render(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var mode = getMode();
    scope.querySelectorAll(PRICE_SELECTOR).forEach(function (node) {
      renderPrice(node, mode);
    });
    document.querySelectorAll('[data-orion-price-toggle]').forEach(function (toggle) {
      toggle.querySelectorAll('[data-orion-price-mode]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.orionPriceMode === mode));
      });
    });
    document.documentElement.dataset.orionPriceDisplay = mode;
  }

  function setMode(mode) {
    var normalizedMode = normalizeMode(mode);
    saveMode(normalizedMode);
    render(document);
    document.dispatchEvent(new CustomEvent('orion:price-display-change', {
      detail: { mode: normalizedMode }
    }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-orion-price-mode]');
    if (!button) return;
    setMode(button.dataset.orionPriceMode);
  });

  function initialize() {
    render(document);
    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return target && (target.matches(PRICE_SELECTOR) ||
          target.querySelector(PRICE_SELECTOR) ||
          target.closest(PRICE_SELECTOR));
      });
      if (!relevant || queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        render(document);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.OrionPriceDisplay = {
    format: function (htCents, mode, currency) {
      var selectedMode = normalizeMode(mode || getMode());
      var displayCents = selectedMode === 'TTC' ? Math.round(Number(htCents) * VAT_MULTIPLIER) : htCents;
      return formatMoney(displayCents, currency) + ' ' + selectedMode;
    },
    getMode: getMode,
    setMode: setMode,
    refresh: render
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
